<template>
  <v-main>
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="4">
          <v-card-text>
            <v-form v-model="valid">
              <v-text-field
                v-model="username"
                label="Username"
                name="username"
                prepend-icon="mdi-account"
                type="text"
                autocapitalize="off"
                :rules="rules.username"
                required
              />

              <v-text-field
                v-model="password"
                label="Password"
                name="password"
                prepend-icon="mdi-lock"
                type="password"
                :rules="rules.password"
                required
              />
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="red"
              block
              :dark="valid"
              @click="login"
              :loading="isLoading"
              :disabled="!valid"
            >
              Login
            </v-btn>
          </v-card-actions>
        </v-col>
      </v-row>
    </v-container>

    <v-snackbar v-model="showSnackbar" multi-line top>
      {{ errorMessage }}
    </v-snackbar>
  </v-main>
</template>

<script>
import EzKasirAPI from "@/library/api";

export default {
  name: "Login",
  data() {
    return {
      username: "",
      password: "",
      showSnackbar: false,
      errorMessage: "",
      isLoading: false,
      valid: false,
      rules: {
        username: [(v) => !!v || "Username wajib diisi"],
        password: [
          (v) => !!v || "Password wajib diisi",
          (v) => v.length >= 6 || "Password wajib diisi 6 karakter atau lebih",
        ],
      },
    };
  },
  methods: {
    login() {
      this.isLoading = true;

      const url = `${process.env.VUE_APP_API_URL}/login`;
      EzKasirAPI.post(url, {
        username: this.username,
        password: this.password,
      })
        .then((response) => {
          localStorage.setItem("isLogin", 1);
          localStorage.setItem("user", JSON.stringify(response.data.data));
          window.location.reload();
        })
        .catch((error) => {
          if (error.response) {
            console.log("error.response", error.response);
            if (error.response.status === 400) {
              this.errorMessage = "Username/password salah";
            }
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.log("error.request", error.request);
            this.errorMessage = "Gagal terhubung, cek koneksi Anda";
          } else {
            // Something happened in setting up the request that triggered an Error
            console.log("error.message", error.message);
          }
          console.log("error.config", error.config);

          this.showSnackbar = true;
          this.isLoading = false;
        });
    },
  },
  created() {
    const isLogin = localStorage.getItem("isLogin");
    const user = localStorage.getItem("user");

    if (isLogin && user) {
      this.$router.push({ name: "homepage.menu" });
    }
  },
};
</script>

<style scoped></style>
